import {PolicyVersionsMenuButton} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/MenuButton/PolicyVersionsMenuButton';
import {ProcedureVersionsMenuButton} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/MenuButton/ProcedureVersionsMenuButton';
import {ProcessVersionsMenuButton} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/MenuButton/ProcessVersionsMenuButton';
import {PolicyVersionsPanelContent} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/PolicyVersionsPanelContent';
import {ProcedureVersionsPanelContent} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/ProcedureVersionsPanelContent';
import {ProcessVersionsPanelContent} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/ProcessVersionsPanelContent';

import type {LeftSidebarElementType} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {
  DetailPolicySerializedType,
  ProcedureHashidSerializedType,
  ProcessHashidSerializedType,
} from 'sweet-types';

export const ProcedureVersionsSidebar: LeftSidebarElementType<ProcedureHashidSerializedType> =
  {
    Panel: ProcedureVersionsPanelContent,
    MenuButton: ProcedureVersionsMenuButton,
    type: 'left',
    sidebarName: 'showVersions',
  };

export const PolicyVersionsSidebar: LeftSidebarElementType<DetailPolicySerializedType> =
  {
    Panel: PolicyVersionsPanelContent,
    MenuButton: PolicyVersionsMenuButton,
    type: 'left',
    sidebarName: 'showVersions',
  };

export const ProcessVersionsSidebar: LeftSidebarElementType<ProcessHashidSerializedType> =
  {
    Panel: ProcessVersionsPanelContent,
    MenuButton: ProcessVersionsMenuButton,
    type: 'left',
    sidebarName: 'showVersions',
  };
